// src/components/room/RoomVoicePanel.jsx
import React from 'react';

export default function RoomVoicePanel({ voice, onClose }) {
  return (
    <div className="voice-panel">
      <div className="voice-header">
        <h4>🎙️ Voice Chat</h4>
        {voice.connected && (
          <button className={`voice-mute-btn ${voice.isMuted ? 'muted' : ''}`} onClick={voice.toggleMute}>
            {voice.isMuted ? 'Unmute' : 'Mute'}
          </button>
        )}
      </div>
      <div className={`voice-status ${voice.connected ? "connected" : "disconnected"}`}>
        {voice.connected ? "✅ Connected" : "❌ Disconnected"}
      </div>
      {voice.participants.length > 0 && (
        <div className="voice-participants">
          <div className="voice-participants-title">In voice ({voice.participants.length})</div>
          {voice.participants.map((p) => (
            <div key={p.id} className="voice-participant">
              <span className="voice-participant-icon">
                {p.isSpeaking ? '🔊' : p.local ? (voice.isMuted ? '🔇' : '🔈') : '🔈'}
              </span>
              <span className="voice-participant-name">{p.name} {p.local && "(You)"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}